module.exports = __webpack_public_path__ + "static/img/title.0bfc8c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/title.png
// module id = wPA2
// module chunks = 7